// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"145":"b220f6a7","273":"0a122a2d","654":"e8382077","984":"12e79cb0"}[chunkId] + ".js";
};